import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer";
import ContentContainer from "../components/ContentContainer";

const ContactPage = () => {
  return (
    <Layout title="Kontakt" description="Ta kontakt med oss på Lokult">
      <MainContainer>
        <section className="mt-20 m-auto w-full max-w-3xl overflow-hidden rounded-2xl border border-white/10 bg-[#131313] shadow-lg">
          <div className="h-1.5 w-full bg-gradient-to-r from-[#0047ff]/60 via-[#0047ff] to-blue-500/70" />
          <div className="p-6 sm:p-10">
            <div className="mb-8 border-b border-white/10 pb-5">
              <p className="text-[10px] font-black tracking-[0.25em] uppercase text-[#0047ff]">
                Kontakt
              </p>
              <h1 className="mt-2 text-2xl sm:text-3xl font-black text-white uppercase tracking-wider">
                Kontakta Lokult
              </h1>
            </div>

            <p className="mb-6 text-sm text-stone-300 leading-relaxed">
              Vad roligt att du vill kontakta oss! Skicka ett mail så hörs vi.
            </p>

            <a
              href="mailto:hej@lokult.se"
              className="inline-flex items-center gap-3 rounded-full border border-[#0047ff]/30 bg-[#0047ff]/10 px-6 py-3.5 text-base font-bold text-[#0047ff] transition-all duration-300 hover:bg-[#0047ff]/20 hover:scale-105 shadow-md"
            >
              hej@lokult.se
            </a>
          </div>
        </section>
      </MainContainer>
    </Layout>
  );
};

export default ContactPage;
